<template>
  <div class="fixed bottom-4 left-4 right-4 z-50 max-w-md mx-auto">
    <div
      class="bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 p-4"
    >
      <div class="flex items-start">
        <div class="flex-shrink-0">
          <svg
            class="w-6 h-6 text-blue-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
            />
          </svg>
        </div>
        <div class="ml-3 flex-1">
          <h3 class="text-sm font-medium text-gray-900 dark:text-gray-100">App Update Available</h3>
          <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
            A new version is available. Update now to get the latest features and improvements.
          </p>
          <div class="mt-4 flex space-x-3">
            <button
              class="text-sm font-medium text-blue-600 hover:text-blue-500 dark:text-blue-400"
              @click="$emit('update')"
            >
              Update
            </button>
            <button
              class="text-sm font-medium text-gray-600 hover:text-gray-500 dark:text-gray-400"
              @click="$emit('dismiss')"
            >
              Later
            </button>
          </div>
        </div>
        <div class="ml-4 flex-shrink-0">
          <button
            class="bg-white dark:bg-gray-800 rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            @click="$emit('dismiss')"
          >
            <span class="sr-only">Close</span>
            <svg
              class="w-5 h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineEmits<{
  update: [];
  dismiss: [];
}>();
</script>

<style scoped>
/* Slide up animation */
.fixed {
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .fixed {
    animation: none;
  }
}
</style>
